<template>
    <modal-view @close-modal="closeModal" :customClassContent="'h-auto overflow-auto'"
        :title="copyItemsResponse.length === 0 ? 'Copy Items to Stores' : ''">
        <div class="promocode-copy-container overflow-auto">
            <div v-if="copyItemsResponse.length === 0">
                <div class="my-5 border rounded-md">
                    <div
                        class="dark:text-gray-300 text-gray-900 text-xl px-3 py-3 dark:bg-gray-900 bg-gray-300 rounded-tl-md rounded-tr-md">
                        Selected
                        Items</div>
                    <div class="border-t px-3 py-3">
                        <div v-for="(item, index) in selectedItems" :key="index"
                            class="cursor-pointer bg-primary text-white inline-block mr-5 px-3 py-2 rounded-md text-sm font-semibold">
                            {{ `${item.sku} - ${item.name}` }}
                        </div>
                    </div>
                </div>
                <div class="my-5 border rounded-md">
                    <div
                        class="dark:text-gray-300 text-gray-900 text-xl px-3 py-3 dark:bg-gray-900 bg-gray-300 rounded-tl-md rounded-tr-md flex justify-between items-center">
                        <div class="flex items-center">
                            Select stores
                        </div>
                        <!-- add select all stores checkbox -->
                        <div class="flex items-center">
                            <input id="default-checkbox" type="checkbox" v-model="selectAllStores"
                                @onchange="handleSelectAllStores"
                                class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 dark:bg-gray-700 dark:border-gray-600">
                            <label for="default-checkbox"
                                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                Select all stores
                            </label>
                        </div>
                    </div>
                    <div class="border-t px-3 py-3 space-y-3">
                        <div v-for="(item, index) in ownerStores" :key="index" @click="toggleSelection(item)" :class="{
                            'bg-blue-500 text-white': selectedStores.find(i => i.name === item.name) || selectAllStores,
                            'bg-gray-200': !selectedStores.find(i => i.name === item.name) && !selectAllStores
                        }" class="cursor-pointer inline-block mr-5 px-3 py-1 rounded-md text-sm font-semibold">
                            {{ item.name }}
                        </div>
                    </div>

                </div>
                <div class="flex items-center mb-4">
                    <input id="default-checkbox" type="checkbox" v-model="canOverwrite" @onchange="handleCanOverwrite"
                        class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 dark:bg-gray-700 dark:border-gray-600">
                    <label for="default-checkbox" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                        Overwrite Existing Items in Store</label>
                </div>
                <hs-button type="submit" label="Copy items to stores" class="mt-5"
                    :isLoading="loadingCopyCatalogToStores" :disabled="isSubmitDisabled" @click="onCopySubmit" />
            </div>
            <div v-else>
                <CopyCatalogResponse :copyItemsResponse="copyItemsResponse" />
                <div class="flex justify-end">
                    <hs-button label="Close" class="mt-5" @click="closeModal" />
                </div>
            </div>
        </div>
    </modal-view>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast } from "vue3-toastify";
import CopyCatalogResponse from './CopyCatalogResponse.vue';

export default {
    props: {
        selectedItems: {
            type: Array,
            required: true
        }
    },
    components: {
        CopyCatalogResponse
    },
    data() {
        return {
            // copyItemsResponse: [],
            ownerStores: [],
            selectedStores: [],
            canOverwrite: false,
            isCopying: false,
            isSubmitDisabled: false,
            selectAllStores: false,
            copyItemsResponse: []
        }
    },
    computed: {
        ...mapGetters(['loadingCopyCatalogToStores'])
    },
    methods: {
        closeModal() {
            this.copyItemsResponse = [];
            this.$emit('close-modal');
        },
        toggleSelection(store) {
            if (this.selectAllStores) {
                this.selectAllStores = false;
                this.selectedStores = [];
            }
            if (this.selectedStores.find(i => i.name === store.name)) {
                this.selectedStores = this.selectedStores.filter(i => i.name !== store.name);
            } else {
                this.selectedStores.push(store);
            }
        },
        handleSelectAllStores() {
            this.selectAllStores = !this.selectAllStores;
            if (this.selectAllStores) {
                this.selectedStores = this.ownerStores;
            } else {
                this.selectedStores = [];
            }
        },
        handleCanOverwrite() {
            this.canOverwrite = !this.canOverwrite;
        },
        onCopySubmit() {
            this.isCopying = true;
            if (this.selectedStores.length === 0) {
                toast.error("Please select at least one store");
                this.isCopying = false;
                return;
            }
            const payload = {
                origin_store_ids: [this.$store.getters.getSelectedStore],
                target_store_ids: this.selectedStores.map(store => store.id),
                skus: this.selectedItems.map(item => item.sku),
                overwrite: this.canOverwrite
            }
            this.$store.dispatch('copyCatalogToStores', payload).then((response) => {
                this.copyItemsResponse = response?.data?.copied_items || [];
                this.isCopying = false;
                // this.closeModal();
                toast.success("Items copied to stores successfully");
            }).catch((error) => {
                toast.error(error?.response?.data?.error?.message || "An error occurred when copying items to stores");
            });
        }
    },
    mounted() {
        this.copyItemsResponse = [];
        this.ownerStores = this.$safeJSONParse(localStorage.getItem("stores")) || [];
    }
}
</script>
